import React from 'react';
import {
  Grid, TextField, FormControl, InputLabel, Select, MenuItem,
  FormGroup, FormControlLabel, Checkbox, Typography, Divider
} from '@mui/material';
import { Office } from '../../models/office';
import { Collect } from '../../models/collect';

interface Props {
  office_id: string;
  setOffice_id: (value: string) => void;
  offices: Office[];
  collectsOffice: Collect[];
  selectedCollects: string[];
  setSelectedCollects: (value: string[]) => void;
  selectAll: boolean;
  setSelectAll: (value: boolean) => void;
  handleCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSelectAll: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const SelectCollectbyOffice: React.FC<Props> = ({
  office_id,
  setOffice_id,
  offices,
  collectsOffice,
  selectedCollects,
  selectAll,
  setSelectAll,
  handleCheckboxChange,
  handleSelectAll,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6} lg={6}>
        <FormControl fullWidth>
          <InputLabel>Seleccionar Oficina</InputLabel>
          <Select label="Seleccionar Oficina" value={office_id} size="small" onChange={(e) => setOffice_id(e.target.value)}>
            {offices.map(office => (
              <MenuItem key={office.id} value={office.id.toString()}>{office.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <FormControl sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
          <InputLabel shrink>Seleccionar Todos</InputLabel>
          <FormControlLabel
            control={<Checkbox size="small" checked={selectAll} onChange={handleSelectAll} indeterminate={selectedCollects.length > 0 && selectedCollects.length < collectsOffice.length} />}
            label="Marcar / Desmarcar todos"
          />
        </FormControl>
      </Grid>

      {collectsOffice.length > 0 && (
        <Grid item xs={12}>
          <Typography variant="subtitle1">Seleccionar Cobros</Typography>
          <FormGroup sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            <Divider sx={{ my: 1 }} />
            {collectsOffice.map(collect => (
              <FormControlLabel
                key={collect.id}
                control={<Checkbox size="small" checked={selectedCollects.includes(collect.id.toString())} onChange={handleCheckboxChange} value={collect.id.toString()} />}
                label={collect.name}
              />
            ))}
          </FormGroup>
        </Grid>
      )}
    </Grid>
  );
};

export default SelectCollectbyOffice;
